<template>
  <div class="row">
    <div class="col-12">
      <h4 class="text-primary mb-5 text-center">
        Cuando selecciones el usuario a reemplazar, se listarán los
        flujos de aprobaciones en los que esté participando
      </h4>
    </div>
    <div class="col-5">
      <list-user
        name="userTarget"
        :block="searchingApprovals"
        label="Usuario a reemplazar"
        v-model="userTarget"
      />
    </div>
    <div class="col-5">
      <list-user
        name="userSubstitute"
        :block="false"
        label="Usuario que reemplaza"
        v-model="userSubstitute"
        ref="userStep"
      />
    </div>
    <div class="col-2 text-center">
      <b-button
        class="mt-5"
        variant="primary"
        @click="saveSubstitutions"
      >
        Guardar
      </b-button>
    </div>
    <div class="col-12 mt-3">
      <b-overlay :show="searchingApprovals">
        <h4 v-if="userTargetApprovals.length">
          Selecciona los flujos en los que deseas aplicar el reemplazo
        </h4>
        <div class="my-4 text-primary" v-if="userTargetApprovals.length">
          <div class="text-primary d-inline">
            <b-form-checkbox
              class="d-inline-block"
              v-model="selectAll"
              @change="selectAllFlows"
            >
            </b-form-checkbox>
            Seleccionar todos
          </div>
        </div>
        <header-substitutions v-if="userTargetApprovals.length" />
        <row-substitutions
          :key="file.idAprobacion"
          v-for="file in userTargetApprovals"
          :file="file"
          @select-flow="selectFlow"
          @unselect-flow="unSelectFlow"
        />
      </b-overlay>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import ListUser from '@/febos/chile/lists/components/ListUser';
import { clTraysList, setSubstituteFlows } from '@/febos/servicios/api/aprobaciones.api';
import RowSubstitutions from '@/febos/chile/approvals/components/substitutions/RowSubstitutions';
import HeaderSubstitutions from '@/febos/chile/approvals/components/substitutions/HeaderSubstitutions';

export default {
  components: {
    ListUser,
    RowSubstitutions,
    HeaderSubstitutions
  },
  data() {
    return {
      userTarget: '',
      userSubstitute: '',
      searchingApprovals: false,
      userTargetApprovals: [],
      selectedFlows: [],
      selectAll: false
    };
  },
  watch: {
    userTarget(newVal) {
      if (newVal !== '') {
        this.searchApprovals();
      }
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'fetchDocumentTypeReferences'
    ]),
    selectAllFlows() {
      this.userTargetApprovals = this.userTargetApprovals.map((flow) => {
        const flowSelected = {
          ...flow,
          selected: this.selectAll
        };
        if (this.selectAll) {
          this.selectedFlows.push(flowSelected.idAprobacion);
        } else {
          this.selectedFlows = [];
        }
        return flowSelected;
      });
    },
    async searchApprovals() {
      this.searchingApprovals = true;
      const { data: { bandejaEntradaList: approvalsTray } } = await clTraysList({
        estado: true,
        tipoBandeja: 'ACTIVASXUSUARIO',
        pagina: 1,
        orden: '-fechaCreacion',
        elementosPorPagina: 100,
        usuarioIdASuplir: this.userTarget
      });
      this.userTargetApprovals = approvalsTray;
      this.searchingApprovals = false;
    },
    selectFlow(file) {
      this.selectedFlows.push(file.idAprobacion);
    },
    unSelectFlow(file) {
      this.selectedFlows = this.selectedFlows
        .filter((flow) => (flow !== file.idAprobacion));
    },
    async saveSubstitutions() {
      if (!this.selectedFlows.length) {
        this.$bvToast.toast(
          'No has seleccionado ningun flujo para reemplazar al usuario',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }
      if (this.userSubstitute === '') {
        this.$bvToast.toast(
          'No has seleccionado al usuario que realizará la suplencia',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }

      try {
        this.searchingApprovals = true;
        const substitute = this.$refs.userStep.getOption();
        await setSubstituteFlows({
          selectedFlows: this.selectedFlows,
          permanent: true,
          userTarget: this.userTarget,
          userSubstitute: this.userSubstitute,
          substituteName: substitute.label,
          from: '',
          to: ''
        });
        this.searchingApprovals = false;
        this.$bvToast.toast(
          'Se guardó el reemplazo exitosamente',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        this.selectedFlows = [];
        this.userTargetApprovals = [];
        this.userTarget = '';
        this.userSubstitute = '';
      } catch {
        this.searchingApprovals = false;
      }
    }
  },
  created() {
    this.fetchDocumentTypeReferences();
    this.searchApprovals();
  }
};
</script>
